import type { Mood, MoodIconColor } from './types'

/** Пути ртов — точно из спеки 01 §5, viewBox 22, глаза — точки в фиксированных координатах. */
export const MOOD_MOUTH_PATH: Record<Mood, string> = {
  HEAVY: 'M7.4 14.8c1-1.6 2.2-2.4 3.6-2.4s2.6.8 3.6 2.4',
  MEH: 'M7.6 14.2h6.8',
  OK: 'M8.2 13.9c.9.6 1.7.9 2.8.9s1.9-.3 2.8-.9',
  GREAT: 'M7.9 13.4c.9 1.2 1.9 1.8 3.1 1.8s2.2-.6 3.1-1.8',
}

export const MOOD_ICON_COLOR: Record<MoodIconColor, string> = {
  MUTED: '#cdc7e4',
  ACCENT: '#ffd79b',
  ON_ACCENT: '#3d1520',
  // Смайлик внутри цветного тега состояния: цвет берётся у самого тега, чтобы не заводить
  // по варианту цвета на каждую тему лейбла.
  INHERIT: 'currentColor',
}
